import { fetchWrapper } from "../Helpers";

export const API_CONSTANT = {
  CHAT: "/owl/chat",
  HISTORY: "/owl/history",
  CRATE_CONVERSATION: "/owl/create-conversation",
  ALL_CONVERSATION: "/owl/conversations",
  DELETE_CONVERSATION: "/owl/conversation",
  AUDIO_CONVERSATION: "/owl/transcribe",
};
export const owlService = {
  streamChat,
  getChatHistory,
  createNewConversation,
  getAllConversations,
  deleteChat,
  transcribeAudio,
};

export async function streamChat(params, onChunk = () => {}) {
  return fetchWrapper.postForStream(`${process.env.REACT_APP_API_URL}/owl/chat`, params);
}

function getChatHistory(sessionId, page = 0, limit = 20) {
  let url = `${process.env.REACT_APP_API_URL}/owl/history`;

  url += `?session_id=${sessionId}`;
  if (page) {
    url += `&page=${page}`;
  }
  if (limit) {
    url += `&limit=${limit}`;
  }
  return fetchWrapper.get(url);
}

function createNewConversation() {
  return fetchWrapper.post(`${process.env.REACT_APP_API_URL + API_CONSTANT.CRATE_CONVERSATION}`);
}

function getAllConversations() {
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL + API_CONSTANT.ALL_CONVERSATION}`);
}

function deleteChat(sessionId) {
  return fetchWrapper.delete(
    `${process.env.REACT_APP_API_URL + API_CONSTANT.DELETE_CONVERSATION}/${sessionId}`
  );
}

// function transcribeAudio(formData, onUploadProgress) {
//   return fetchWrapper
//     .postFile("/owl/transcribe", formData, onUploadProgress)
//     .then((response) => {
//       console.log("response",response)
//       const decodedString = atob(response);
//       console.log("decodedString",decodedString)
//       const res = JSON.parse(decodedString.replace(/^"|"$/g, "").replace(/\\"/g, '"'));
//       console.log("🚀 ~ .then ~ res:", res)
//       if (!res.success) {
//         throw new Error(response.message || "Transcription failed");
//       }
//       return res;
//     })
//     .catch((error) => {
//       console.error("Transcription API error:", error);
//       throw error;
//     });
// }
function transcribeAudio(formData, onUploadProgress) {
  return fetchWrapper
    .postFile("/owl/transcribe", formData, onUploadProgress)
    .then((response) => {
      try {
        const res = typeof response === 'string' ? JSON.parse(response) : response;
        
        if (!res.success) {
          throw new Error(res.message || "Transcription failed");
        }
        return res;
      } catch (parseError) {
        // If direct parse fails, try cleaning the string
        try {
          const cleanedString = response
            .replace(/^"|"$/g, "")
            .replace(/\\"/g, '"');
          const res = JSON.parse(cleanedString);
          
          if (!res.success) {
            throw new Error(res.message || "Transcription failed");
          }
          return res;
        } catch (finalError) {
          throw new Error(`Failed to parse response: ${finalError.message}`);
        }
      }
    })
    .catch((error) => {
      console.error("Transcription API error:", error);
      throw error;
    });
}
